import {RegistroEntrenador, RegistroEntrenadorJSON } from '../RegistroEntrenador/RegistroEntrenador';
export interface RegistroEntrenadorAntecedenteJSON {
    reante_id: string;
    reante_reid: string;
    reante_detalle: string;
    reante_tipo: string;
}

export class RegistroEntrenadorAntecedente {
    protected constructor(
    private id: string,
    private reid: string,
    private detalle: string,
    private tipo: string) {}

    static createFrom( id: string,
    reid: string,
    detalle: string,
    tipo: string) {
        return new this( id,
        reid,
        detalle,
        tipo)
    }

    isIdentifiedBy(anId: string): boolean {
        return this.id === anId
    }

    isIdentifiedAs(aEntity: RegistroEntrenadorAntecedente) {
        if(this.id){
            return aEntity.isIdentifiedBy(this.id)
        } else {
            return false
        }

    }

    static fromJSON(entity: RegistroEntrenadorAntecedenteJSON) {
        return RegistroEntrenadorAntecedente.createFrom( entity.reante_id,
        entity.reante_reid,
        entity.reante_detalle,
        entity.reante_tipo)
    }

    toJSON(): RegistroEntrenadorAntecedenteJSON {
        return {
            reante_id: this.getId(),
            reante_reid: this.getReid(),
            reante_detalle: this.getDetalle(),
            reante_tipo: this.getTipo()
        }

    }

    getId(): string { return this.id; }

    getReid(): string { return this.reid; }

    getDetalle(): string { return this.detalle; }

    getTipo(): string { return this.tipo; }


}

